// Header Armonia: opac la scroll + meniu mobil.
// Fără dependențe — Dawn încarcă deja destul JS, iar aici e vorba de două clase.
(function () {
  const header = document.querySelector('.armonia-header');
  if (!header) return;

  // Înălțimea reală a headerului, publicată ca variabilă CSS. O foloseau ca număr fix
  // distanțierul de sub header (armonia-chrome.css) și panoul de căutare
  // (armonia-diverse.css); de când headerul are și o bară de utilitare opțională, un 70px
  // scris de mână ori lasă conținutul pe sub header, ori deschide panoul la distanță de el.
  const inaltime = () =>
    document.documentElement.style.setProperty('--armonia-header-h', header.offsetHeight + 'px');
  inaltime();
  window.addEventListener('resize', inaltime, { passive: true });
  // fonturile schimbă înălțimea rândurilor după primul layout
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(inaltime);

  // O singură funcție decide când headerul e opac. Derularea, un panou de meniu deschis și
  // căutarea deschisă cer același lucru — fundal plin, sub care fotografia nu se mai vede —
  // iar trei bucăți de cod care își dispută aceeași clasă se calcă între ele: la închiderea
  // căutării, „scoate solid" ar fi șters și starea cerută de scroll.
  // Pragul e sub înălțimea headerului: sub el, textul alb ar ajunge peste fundal deschis.
  const sincronizeaza = () => {
    header.classList.toggle(
      'solid',
      header.dataset.transparent !== 'true' ||
        window.scrollY > 60 ||
        header.classList.contains('meniu') ||
        header.classList.contains('mobil') ||
        header.classList.contains('cauta')
    );
  };
  // Panoul de căutare stă în alt fișier (armonia-cautare.liquid); primește funcția, ca
  // regula „când e opac" să rămână scrisă o singură dată.
  header.armoniaSincronizeaza = sincronizeaza;
  sincronizeaza();
  window.addEventListener('scroll', sincronizeaza, { passive: true });

  // Panourile cu subcategorii le deschide CSS-ul (hover/focus), deci nu există un eveniment
  // „s-a deschis panoul": starea se citește din `:hover`/`:focus-within` după ce browserul
  // a apucat s-o actualizeze, adică în cadrul următor. Peste hero, un panou ivory atârnat de
  // un header transparent arată ca o hârtie lipită pe fotografie; cât e deschis, headerul
  // trece pe opac și panoul devine continuarea lui.
  const nav = header.querySelector('.mainnav');
  if (nav) {
    const stareaPanourilor = () => {
      header.classList.toggle('meniu', !!nav.querySelector('.mi:hover, .mi:focus-within'));
      sincronizeaza();
    };
    ['pointerover', 'pointerout', 'focusin', 'focusout'].forEach((ev) =>
      nav.addEventListener(ev, () => requestAnimationFrame(stareaPanourilor))
    );
  }

  const burger = header.querySelector('.burger');
  const meniu = document.getElementById('armonia-mmenu');
  if (!burger || !meniu) return;

  const seteaza = (deschis) => {
    meniu.classList.toggle('open', deschis);
    meniu.hidden = !deschis;
    burger.setAttribute('aria-expanded', String(deschis));
    document.body.style.overflow = deschis ? 'hidden' : '';
    // Headerul rămâne deasupra panoului (z-index 60 > 55), deci trebuie să fie opac cât e
    // meniul deschis: altfel gradientul lui întunecat și textul alb stau peste ivory.
    header.classList.toggle('mobil', deschis);
    sincronizeaza();
  };

  burger.addEventListener('click', () => seteaza(!meniu.classList.contains('open')));
  meniu.addEventListener('click', (e) => {
    if (e.target.tagName === 'A') seteaza(false);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && meniu.classList.contains('open')) {
      seteaza(false);
      burger.focus();
    }
  });
})();
